import {
    useContext,
    useState
} from 'react';

import {
    Autocomplete,
    Box,
    Button,
    TextField,
    Typography
} from '@mui/material';
import { styled } from '@mui/material/styles';

import { useFormik } from 'formik';
import ReCAPTCHA from 'react-google-recaptcha';

import * as Yup from 'yup';

const RECAPTCHA_SITE_KEY = process.env.RECAPTCHA_SITE_KEY;
import MarketingNavigation from '../../navigation/marketing';
import { RequestNextApi } from '../../api/Request';
import { ShowNotification } from '../../utils/notification/snackbarUtils';
import { ProgressContext } from '../../components/Context/progressContext';

const initialValues = {
    name: '',
    email: '',
    phone: '',
    message: ''
};

const validationSchema = Yup.object().shape({
    email: Yup.string().email('Invalid email').required('Required'),
});

const StyledTextField = styled(TextField)({
    '& .MuiOutlinedInput-root': {
        '&:hover fieldset': {
            borderColor: '#78A8AF',
        },
        '&.Mui-focused fieldset': {
            borderColor: '#78A8AF',
        },
    },
});

export default function ForgotPassword(props) {
    const { state: progressContext, update: updateProgress } = useContext(ProgressContext);
    const [state, setState] = useState();
    const [states, setStates] = useState([]);
    const [autoCompleteKey, setAutoCompleteKey] = useState(false);
    const [recaptchaSuccess, setRecaptchaSuccess] = useState(false);

    const formik = useFormik({
        initialValues,
        validationSchema,
    });

    const onChangeCaptcha = (value) => {
        if (value) {
            setRecaptchaSuccess(true);
        } else {
            setRecaptchaSuccess(false);
        }
    };


    const handleSubmit = async (e) => {
        e.preventDefault();
        try {
            updateProgress({ isLoading: true });
            const res = await RequestNextApi.post('/user/user-forgot-password',
                {

                    email: formik.values.email,

                }
            );
            if (res.data && res.data.success) {
                ShowNotification.success(res.data.message);
                formik.values.email = '';
            } else {
                ShowNotification.error(res.data.message);
            }
        } catch (error) {
            ShowNotification.error('Sending message failed');
        }
        updateProgress({ isLoading: false });
    };

    return (
        <MarketingNavigation>
            <div className='mx-auto max-w-7xl px-6 lg:px-8 mt-16' >
                <div className='flex flex-col justify-center items-center w-full h-full '>
                    <form onSubmit={handleSubmit} className='w-full' style={{ maxWidth: 800 }}>
                        <Typography
                            gutterBottom variant="h5"
                            component="div"
                            className='text-secondary-500'
                        >
                            Forgot Password?
                        </Typography>

                        <Typography
                            component="div"
                            className='text-orange-400 text-xl text-start mb-6'
                        >
                            Password reset instructions will be sent to you via email.
                        </Typography>

                        <StyledTextField
                            label="Email"
                            color="third"
                            size="small"
                            fullWidth
                            id="email"
                            name="email"
                            required
                            {...formik.getFieldProps("email")}
                            error={formik.touched.email && formik.errors.email}
                            helperText={formik.touched.email && formik.errors.email}
                        />

                        <div className='mt-6'>
                            <ReCAPTCHA
                                sitekey={RECAPTCHA_SITE_KEY}
                                onChange={onChangeCaptcha}
                            />
                        </div>

                        <div className='text-start mt-6'>
                            <Button
                                variant="contained"
                                className='bg-secondary-500 hover:bg-secondary-500'
                                type='submit'
                                disabled={!recaptchaSuccess}
                            >
                                Send Me Instructions
                            </Button>
                        </div>
                    </form>
                </div>
            </div>
        </MarketingNavigation>
    )
}
ForgotPassword.getLayout = page => <>{page}</>;
ForgotPassword.isPublic = true;
